import instance from './testing.instance';

export const uploadBillFile = file => {
    const formData = new FormData();
    formData.append('file', file);

    return instance.post('/lector/extract/?async=1', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getBillProcessingProgress = recordId =>
    instance.get(`/lector/archivos/${recordId}/progreso/`);

export const getBillProcessingHistory = ({
    estado = '',
    batch_id = '',
    fecha_desde = '',
    fecha_hasta = '',
    search = '',
    page = 1,
    page_size = 20,
} = {}) =>
    instance.get('/lector/archivos/', {
        params: {
            estado,
            batch_id,
            fecha_desde,
            fecha_hasta,
            search,
            page,
            page_size,
        },
    });

export const abortBillProcessing = recordId =>
    instance.post(`/lector/archivos/${recordId}/abortar/`);

export const retryBillProcessing = recordId =>
    instance.post(`/lector/archivos/${recordId}/reintentar/`);

export const getBills = ({
    tipo = '',
    estado = '',
    calidad = '',
    proveedor_id = '',
    proveedor = '',
    tipo_servicio = '',
    periodo_desde = '',
    periodo_hasta = '',
    fecha_emision_desde = '',
    fecha_emision_hasta = '',
    numero_factura = '',
    moneda = '',
    jerarquia_id = '',
    es_huerfana = '',
    score_min = '',
    score_max = '',
    search = '',
    ordenar_por = 'periodo_desde',
    ordenar_dir = 'desc',
    page = 1,
    page_size = 20,
} = {}) =>
    instance.get('/lector/api/facturas/', {
        params: {
            tipo,
            estado,
            calidad,
            proveedor_id,
            proveedor,
            proveedor_nombre: proveedor,
            tipo_servicio,
            periodo_desde,
            periodo_hasta,
            fecha_emision_desde,
            fecha_emision_hasta,
            numero_factura,
            moneda,
            jerarquia_id,
            es_huerfana,
            score_min,
            score_max,
            search,
            ordenar_por,
            ordenar_dir,
            page,
            page_size,
        },
    });

export const exportBillsCsv = params =>
    instance.get('/lector/api/facturas/export/', {
        params,
        responseType: 'blob',
    });

export const downloadBillFile = url =>
    instance.get(url, {
        responseType: 'blob',
    });

export const getBillScores = ({
    calidad = 'todos',
    jerarquia_id = '',
    es_huerfana = '',
    page = 1,
    page_size = 10,
} = {}) =>
    instance.get('/lector/api/scores/', {
        params: {
            calidad,
            jerarquia_id,
            es_huerfana,
            page,
            page_size,
        },
    });

export const getBillDetail = (tipo, id) =>
    instance.get(`/lector/api/scores/${tipo}/${id}/`);

export const deleteBill = (tipo, id) =>
    instance.delete(`/lector/api/scores/${tipo}/${id}/`);

export const correctBillField = (tipo, pk, field, value) =>
    instance.patch(`/lector/api/scores/${tipo}/${pk}/campo/`, { field, value: String(value) });

export const correctBillFields = (tipo, pk, campos) =>
    instance.patch(`/lector/api/scores/${tipo}/${pk}/campos/`, { campos });

export const getOrphanBills = () =>
    instance.get('/lector/api/facturas/huerfanas/');

export const getOrphanBillsDetailed = () =>
    instance.get('/lector/api/facturas/huerfanas/', { params: { detalle: true } });

export const linkBill = (tipo, id, jerarquiaId) =>
    instance.patch(`/lector/api/facturas/${tipo}/${id}/vincular/`, { jerarquia_id: jerarquiaId });

export const unlinkBill = (tipo, id) =>
    instance.patch(`/lector/api/facturas/${tipo}/${id}/vincular/`, { jerarquia_id: null });

export const discardBillSuggestion = (tipo, id) =>
    instance.delete(`/lector/api/facturas/${tipo}/${id}/sugerencia/`);

export const markBillsAsReviewed = (items, human_revision = true) =>
    instance.patch('/lector/api/facturas/revision/', { items, human_revision });

export const getPendingRevisionBills = (params = {}) =>
    instance.get('/lector/api/facturas/pendientes-revision/', { params });

export const patchVerificacionAutomatica = body =>
    instance.patch('/lector/api/facturas/verificacion-automatica/', body);

const appendRepeatedParam = (params, key, value) => {
    if (Array.isArray(value)) {
        value
            .filter(item => item !== '' && item !== null && item !== undefined)
            .forEach(item => params.append(key, item));
        return;
    }

    if (value !== '' && value !== null && value !== undefined) {
        params.append(key, value);
    }
};

export const getConsumptionHistory = ({
    fecha_desde = '',
    fecha_hasta = '',
    granularidad = 'mensual',
    tipo_servicio = '',
    jerarquia_id = [],
    proveedor_id = '',
} = {}) => {
    const params = new URLSearchParams();

    appendRepeatedParam(params, 'fecha_desde', fecha_desde);
    appendRepeatedParam(params, 'fecha_hasta', fecha_hasta);
    appendRepeatedParam(params, 'granularidad', granularidad);
    appendRepeatedParam(params, 'tipo_servicio', tipo_servicio);
    appendRepeatedParam(params, 'jerarquia_id', jerarquia_id);
    appendRepeatedParam(params, 'proveedor_id', proveedor_id);

    const queryString = params.toString();

    return instance.get(`/lector/api/consumos/${queryString ? `?${queryString}` : ''}`);
};

export const getGestiones = ({
    proveedor_id = '',
    tipo_servicio = '',
    jerarquia_id = '',
    estado = '',
    fecha_desde = '',
    fecha_hasta = '',
    search = '',
    page = 1,
    page_size = 20,
} = {}) =>
    instance.get('/lector/api/gestiones/', {
        params: {
            proveedor_id,
            tipo_servicio,
            jerarquia_id,
            estado,
            fecha_desde,
            fecha_hasta,
            search,
            page,
            page_size,
        },
    });

export const getGestionDetail = gestionId =>
    instance.get(`/lector/api/gestiones/${gestionId}/`);

export const createGestion = body =>
    instance.post('/lector/api/gestiones/', body);

export const patchGestion = (gestionId, body) =>
    instance.patch(`/lector/api/gestiones/${gestionId}/`, body);

export const deleteGestion = gestionId =>
    instance.delete(`/lector/api/gestiones/${gestionId}/`);

export const getGestionActivities = (gestionId, params = {}) =>
    instance.get(`/lector/api/gestiones/${gestionId}/actividades/`, {
        params,
    });

export const createGestionActivity = (gestionId, body) =>
    instance.post(`/lector/api/gestiones/${gestionId}/actividades/`, body);

export const linkGestionFacturas = (gestionId, body) =>
    instance.post(`/lector/api/gestiones/${gestionId}/facturas/`, body);

export const unlinkGestionFactura = (gestionId, linkId) =>
    instance.delete(`/lector/api/gestiones/${gestionId}/facturas/${linkId}/`);

export const createManualBill = payload =>
    instance.post('/lector/api/facturas/manual/', payload);

export const getProveedoresLector = ({ tipo_servicio = '', search = '', page = 1, page_size = 100 } = {}) =>
    instance.get('/lector/api/proveedores/', { params: { tipo_servicio, search, page, page_size } });
